import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {
  FormGroup,
  Label,
  Input,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import HelpIcon from '../HelpIcon';

import {
  userCan,
  userIsAdmin,
} from '../../helpers/Auth';
import { getSetting } from '../../helpers/Settings';

const AccessModalAccessType = ({
  mode,
  accessType,
  radioName,
  labels,
  handleChangeAccessType,
}) => {
  const intl = useIntl();

  let publicEnabled = userIsAdmin();
  if (mode === 'collections') {
    publicEnabled = userCan('collection.create_public');
  }
  if (mode === 'files') {
    publicEnabled = userCan('file.create_public');
  }

  let modeText = mode;
  if (mode === 'collections') {
    modeText = 'Collections';
  }

  const publicDisabled = !publicEnabled && accessType !== 'public';

  return (
    <div className="access-type">
      <div className="access-type-form">
        {!(getSetting('disable_public_files') && mode === 'files') && (
          <FormGroup check>
            <Label className={classnames('access-type-item', { disabled: publicDisabled })} check>
              <Input
                type="radio"
                name={radioName}
                value="public"
                checked={accessType === 'public'}
                disabled={publicDisabled}
                onChange={handleChangeAccessType}
              />
              {' '}
              <h5 className="access-type-title">
                {intl.formatMessage({ defaultMessage: 'Open' })}
                {(!publicEnabled && accessType !== 'public') ? (
                  <HelpIcon id="public-no-permissions-tooltip">
                    {intl.formatMessage({
                      defaultMessage: `You do not have permissions to create Open {modeText}`,
                    }, { modeText })}
                  </HelpIcon>
                ) : (
                  <>
                    {labels === 'tooltips' && (
                      <HelpIcon id="access-public-tooltip" placement="right">
                        {intl.formatMessage({
                          defaultMessage: 'Visible to all users in your workspace',
                        })}
                      </HelpIcon>
                    )}
                  </>
                )}
              </h5>
              {labels === 'labels' && (
                <p className="access-type-details">
                  {intl.formatMessage({
                    defaultMessage: 'Visible to all users in your workspace',
                  })}
                </p>
              )}
            </Label>
          </FormGroup>
        )}
        <FormGroup check>
          <Label className="access-type-item" check>
            <Input
              type="radio"
              name={radioName}
              value="private"
              checked={accessType === 'private'}
              onChange={handleChangeAccessType}
            />
            {' '}
            <h5 className="access-type-title">
              {intl.formatMessage({ defaultMessage: 'Restricted' })}
              {labels === 'tooltips' && (
                <HelpIcon id="access-private-tooltip" placement="right">
                  {intl.formatMessage({ defaultMessage: 'Visible only to users and Teams you add' })}
                </HelpIcon>
              )}
            </h5>
            {labels === 'labels' && (
              <p className="access-type-details">
                {intl.formatMessage({ defaultMessage: 'Visible only to users and Teams you add' })}
              </p>
            )}
          </Label>
        </FormGroup>
      </div>
    </div>
  );
};

AccessModalAccessType.propTypes = {
  mode: PropTypes.string.isRequired,
  accessType: PropTypes.string,
  radioName: PropTypes.string,
  labels: PropTypes.string,
  handleChangeAccessType: PropTypes.func.isRequired,
};

AccessModalAccessType.defaultProps = {
  accessType: null,
  radioName: 'access-type',
  labels: 'labels',
};

export default AccessModalAccessType;
